module.exports = __webpack_public_path__ + "static/media/cv-lindsay-vannebenne.ae0161b1.pdf";